import React, { useMemo } from 'react'
import dompurify from 'dompurify'
import '@progress/kendo-theme-default/dist/all.css'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useTranslation } from "react-i18next"

import htmlContent from '../../../utils/termsandconditions'
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import './dialog-terms-conds.css'
import { LocalStorageService } from '../../../services'

const localStorageService = new LocalStorageService()
/* === Custom component title for dialog error === */
const CustomTitleBar = () => {
  const { t } = useTranslation()

  const customTitleBarStyles = {
    color: '#FFFFFF',
    fontSize: '20px',
    textAlign: 'left',
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: '600'
  }
  return (<div style={customTitleBarStyles}><span>{t('dialogSignRequestPure.titleDialogSignRequest')}</span></div>)
}

function DialogTermsCond(props) {
  const language = localStorageService.getLocalStorageItem("preferredLanguage")
  const urlToCall = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_RELATIVE_URL_PDF_TERMS_CONDS}`.replace("{languageToReplace}", language ?? "es")

  const pdfAWS = useMemo(() => <PdfViewerAction url={urlToCall} isExtended={false} isSSRActive={false} />, [props.modalTermsCond, language])

  return (
    <>
      {props.modalTermsCond &&
        <Dialog title={<CustomTitleBar />} onClose={() => { props.openModalTermsCond(false) }} height={500} width={750}>
          <div className='dialogTermsCond-pdf'>
            {pdfAWS}
          </div>
        </Dialog>
      }
    </>
  )
}
export { DialogTermsCond as default }